/* Grilldorado: Energielabel bei Variantenwechsel auf die gewählte Bildschirmgröße umschalten. */
(function () {
  if (typeof subscribe !== 'function' || typeof PUB_SUB_EVENTS === 'undefined') return;
  if (window.gdEnergieAktiv) return;
  window.gdEnergieAktiv = true;

  subscribe(PUB_SUB_EVENTS.variantChange, function (event) {
    var data = event && event.data;
    if (!data || !data.sectionId || !data.variant || !data.variant.options) return;
    var energie = document.getElementById('GD-Energie-' + data.sectionId);
    if (!energie) return;
    var eintraege = energie.querySelectorAll('.gd-energie__eintrag');
    var treffer = null;
    eintraege.forEach(function (e) {
      if (data.variant.options.indexOf(e.getAttribute('data-gd-groesse')) !== -1) treffer = e;
    });
    if (treffer) {
      eintraege.forEach(function (e) { e.hidden = e !== treffer; });
    }
  });
})();
